import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SelectionListComponent } from './selection-list.component';
import { SelectionListItemComponent } from './selection-list-item.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SelectionListComponent,
    SelectionListItemComponent
  ],
  exports: [
    SelectionListComponent,
    SelectionListItemComponent
  ]
})
export class SelectionListModule {
}
